import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import camelCaseRecursive from 'camelcase-keys-recursive';

import CompanyInfo from '../../Shared/Company/CompanyInfo';
import { CompanyTopView } from '../../../components';
import { showCompanyRequest } from '../../../requests/companies';

const basicCompany = {
  id: undefined,
  bankAccountsAttributes: [],
  compensationFund: {},
  economicActivity: {},
  safetyOrganization: {},
  businessLogo: {
    fileUrl: ''
  }
};

const CompanyShow = ({ match }) => {
  const [company, setCompany] = useState(basicCompany);
  const { currentCompany, signedIn } = useSelector(state => state.auth);
  const dispatch = useDispatch();

  const handleSuccessShow = response => {
    setCompany(camelCaseRecursive(response.data));
  };

  const fetchCompany = useCallback(() => {
    if (currentCompany !== '') {
      const companyId = match.params.id || currentCompany.id;
      if (companyId && signedIn) {
        showCompanyRequest(companyId, {
          dispatch,
          successCallback: handleSuccessShow
        });
      }
    }
  }, [currentCompany, match, signedIn, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    fetchCompany();
  }, [fetchCompany]);

  return (
    <>
      <CompanyTopView company={company} />
      <CompanyInfo company={company} isProfile />
    </>
  );
};

export default CompanyShow;
